<template>
  <el-dialog :visible.sync="dialogVisible" :show-close="false">
    <img
      class="close-img"
      src="@/assets/img/images/icon/close-icon.png"
      @click="dialogVisible = false"
    />
    <p class="p1">{{ $t('verifyUser.title') }}</p>
    <el-form class="mt20" :model="formData" :rules="rules" ref="ruleFormAuthentication">
      <el-form-item :label="$t('verifyUser.country')" prop="country">
        <el-select
          :placeholder="$t('authentication.country_placeholder')"
          filterable
          v-model="formData.country"
          style="width: 100%"
        >
          <el-option
            v-for="group in countryList"
            :key="group.code"
            :value="group.code"
            :label="group.cnName"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('verifyUser.name')" prop="name">
        <el-input
          v-model="formData.name"
          :placeholder="$t('tipsVal.inputPlaceholder')"
		  maxlength="50"
        />
      </el-form-item>
      <el-form-item :label="$t('verifyUser.familyName')" prop="familyName">
        <el-input
          v-model="formData.familyName"
          :placeholder="$t('tipsVal.inputPlaceholder')"
		      maxlength="50"
        />
      </el-form-item>
      <el-form-item :label="$t('verifyUser.idcardNo')" prop="idcardNo">
        <el-input
          v-model="formData.idcardNo"
          :placeholder="$t('tipsVal.inputPlaceholder')"
		      maxlength="100"
        />
      </el-form-item>
      <el-form-item :label="$t('verifyUser.tips.idcardImg')">
        <div class="mt20">
          <el-upload
            v-loading="loading_front"
            :action="uploadUrl"
            :headers="headers"
            :show-file-list="false"
            :on-success="handleAvatarSuccess_front"
            :on-error="handleAvatarError_front"
            :before-upload="beforeAvatarUpload_front"
          >
            <div class="img-box">
              <div
                class="c-flex-center c-flex-column"
                v-if="!formData.idcardFrontImgUrl"
              >
                <img
                  class="upload-icon"
                  src="@/assets/img/images/icon/upload-img.png"
                />
                <p class="mt10">
                  <span class="font-blue">{{$t('verifyUser.upload')}}</span>{{$t('verifyUser.tips.type')}}
                </p>
                <p>{{$t('verifyUser.tips.size')}}</p>
              </div>
              <img
                v-else
                class="upload-img"
                :src="formData.idcardFrontImgUrl"
              />
            </div>
          </el-upload>
          <p class="text-center">{{$t('verifyUser.tips.idcardFrontImgurl')}}</p>
          <el-upload
            v-loading="loading_back"
            :action="uploadUrl"
            :headers="headers"
            :show-file-list="false"
            :on-success="handleAvatarSuccess_back"
            :on-error="handleAvatarError_back"
            :before-upload="beforeAvatarUpload_back"
          >
            <div class="img-box">
              <div
                class="c-flex-center c-flex-column"
                v-if="!formData.idcardBackImgUrl"
              >
                <img
                  class="upload-icon"
                  src="@/assets/img/images/icon/upload-img.png"
                />
                <p class="mt10">
                  <span class="font-blue">{{$t('verifyUser.upload')}}</span>{{$t('verifyUser.tips.type')}}
                </p>
                <p>{{$t('verifyUser.tips.size')}}</p>
              </div>
              <img v-else class="upload-img" :src="formData.idcardBackImgUrl" />
            </div>
          </el-upload>
          <p class="text-center">{{$t('verifyUser.tips.idcardFrontImgurl')}}</p>
          <div class="tips-box">
            <div class="tips-box1">{{$t('verifyUser.reminder')}}</div>
            <div class="tips-box2">
              {{$t('verifyUser.reminderValue')}}
            </div>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div class="btn-box">
      <div class="btn2" @click="confirmClick">{{ $t('buy_box.confirm') }}</div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { compressAccurately } from 'image-conversion';
export default {
  computed: {
    ...mapState(["user", "errorCode"]),
  },
  data() {
    return {
      dialogVisible: false,
      formData: {
        country: "",
        name: "",
        familyName: "",
        idType: "idcard",
        idcardNo: "",
        idcardFrontImgUrl: "",
        idcardBackImgUrl: "",
        handonImgurl: "",
      },
      countryList: [],

      uploadUrl: "",
      headers: {
        Authorization: "",
      },
      loading_hand: false,
      loading_front: false,
      loading_back: false,
      rules: {
        country: [
          {
            required: true,
            message: this.$t("validate.country_require"),
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: this.$t("validate.name_require"),
            trigger: "blur",
          },
        ],
        familyName: [
          {
            required: true,
            message: this.$t("validate.familyName_require"),
            trigger: "blur",
          },
        ],
        idcardNo: [
          {
            required: true,
            message: this.$t("validate.id_require"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    init() {
      this.getkycCountries();
      this.createUploadInfo();
      this.dialogVisible = true;
    },
    getkycCountries() {
      this.$axios.post("/user/getKycCountries", {}).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          this.countryList = res.data.data;
        }
      });
    },
    createUploadInfo() {
      this.uploadUrl = this.$axios.defaults.baseURL + "/upload/save";
      this.headers.Authorization = window.localStorage.getItem("jwt-token");
      this.headers["X-Exchange-Info"] =
        "language=" +
        this.$i18n.locale +
        "&source=web&priceCurrency=CNY&version=1.0.0";
    },
    handleAvatarSuccess_front(res, file) {
      this.formData.idcardFrontImgUrl = res.data.imageUrl;
      this.loading_front = false;
    },
    handleAvatarSuccess_back(res, file) {
      this.formData.idcardBackImgUrl = res.data.imageUrl;
      this.loading_back = false;
    },
    handleAvatarError_front(err, file, fileList) {
      this.$message.error(this.$t("validate.upload_error"));
      this.loading_front = false;
    },
    handleAvatarError_back(err, file, fileList) {
      this.$message.error(this.$t("validate.upload_error"));
      this.loading_back = false;
    },
    async beforeAvatarUpload_front(file) {
      this.loading_front = true;
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      const sizeLimit = 2 * 1024 * 1024; // 2MB
      if (!isJPG) {
        this.$message.error(this.$t("validate.upload_type"));
        return (this.loading_front = false);
      }
      // 小于等于 2MB，直接上传，不压缩
      if (file.size <= sizeLimit) return true;
      try {
        // 显示压缩中的提示
        this.$message({
          message: this.$t("validate.upload_compress"),
          type: 'info',
          duration: 0, // 不自动关闭
        });

        // 压缩到 200KB（可根据需求调整）
        const targetSizeKB = 200;
        const compressedFile = await compressAccurately(file, targetSizeKB);
        
        // 关闭提示
        this.$message.closeAll();

        // 输出压缩结果
        // const compressedSizeMB = (compressedFile.size / 1024 / 1024).toFixed(2);
        // const compressionRatio = ((1 - compressedFile.size / file.size) * 100).toFixed(2);
        
        // this.$message.success(
        //   `压缩完成！原始大小: ${(file.size / 1024 / 1024).toFixed(2)}MB，` +
        //   `压缩后: ${compressedSizeMB}MB，压缩率: ${compressionRatio}%`
        // );
        
        // 返回压缩后的文件，替换原文件上传
        return compressedFile;
      } catch (error) {
        // console.error('图片压缩失败:', error);
        // this.$message.error('图片压缩失败，将上传原文件');
        this.$message.closeAll();
        // 压缩失败时返回原文件，保证上传流程不中断
        return file;
      }
    },
    async beforeAvatarUpload_back(file) {
      this.loading_back = true;
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";

      const sizeLimit = 2 * 1024 * 1024; // 2MB
      if (!isJPG) {
        this.$message.error(this.$t("validate.upload_type"));
        return (this.loading_back = false);
      }
      // 小于等于 2MB，直接上传，不压缩
      if (file.size <= sizeLimit) return true;
      try {
        // 显示压缩中的提示
        this.$message({
          message: this.$t("validate.upload_compress"),
          type: 'info',
          duration: 0, // 不自动关闭
        });

        // 压缩到 200KB（可根据需求调整）
        const targetSizeKB = 200;
        const compressedFile = await compressAccurately(file, targetSizeKB);
        
        // 关闭提示
        this.$message.closeAll();

        // 输出压缩结果
        // const compressedSizeMB = (compressedFile.size / 1024 / 1024).toFixed(2);
        // const compressionRatio = ((1 - compressedFile.size / file.size) * 100).toFixed(2);
        
        // this.$message.success(
        //   `压缩完成！原始大小: ${(file.size / 1024 / 1024).toFixed(2)}MB，` +
        //   `压缩后: ${compressedSizeMB}MB，压缩率: ${compressionRatio}%`
        // );
        
        // 返回压缩后的文件，替换原文件上传
        return compressedFile;
      } catch (error) {
        // console.error('图片压缩失败:', error);
        // this.$message.error('图片压缩失败，将上传原文件');
        this.$message.closeAll();
        // 压缩失败时返回原文件，保证上传流程不中断
        return file;
      }
    },
    confirmClick() {
      console.log("this.formData", this.formData);
      this.$refs.ruleFormAuthentication.validate((valid) => {
        if (
          !valid ||
          this.formData.idcardBackImgUrl === "" ||
          this.formData.idcardFrontImgUrl === ""
        ) {
          this.$message({
            type: "error",
            message: this.$t("validate.incomplete_information"),
          });
        } else {
          this.$axios.post("/user/certify", this.formData).then((res) => {
            if (res.data.code === this.errorCode.ok) {
              this.$message({
                type: "success",
                message: this.$t("authentication.success"),
              });
              this.$store.dispatch("actions_getUserInfo").then((res) => {
                this.dialogVisible = false;
              });
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-upload {
  width: 100%;
}
.img-box {
  width: 100%;
  height: 264px;
  display: flex;
  cursor: pointer;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  border: 1px dashed #707070;
  border-radius: 12px 12px 12px 12px;
  .font-blue {
    color: var(--primary-color);
    text-decoration: underline;
  }
  .upload-icon {
    width: 54px;
    height: 54px;
  }
}
/deep/ .el-upload:focus {
  color: #606266 !important;
}
.img-box:hover {
  background: rgba(162, 176, 239, 0.15);
  border: 1px dashed var(--primary-color);
}
.tips-box {
  margin-top: 20px;
  .tips-box1 {
    height: 28px;
    padding: 0 6px;
    width: fit-content;
    line-height: 28px;
    background: var(--box-bg-color);
    border-radius: 4px 4px 4px 4px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: var(--primary-color);
  }
  .tips-box2 {
    height: 48px;
    line-height: 48px;
    margin-top: 15px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    border: 1px dashed var(--primary-color);
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: var(--primary-color);
  }
}
.upload-img {
  width: 100%;
  object-fit: none;
}
.text-center {
  text-align: center;
}

/deep/.el-dialog {
  width: 700px;
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 32px 30px;
  }
  .el-form-item__label {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
  }

  .el-input__suffix,
  .el-input__suffix-inner {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-input-group--append {
    gap: 16px;
    display: flex;
  }
  .el-input__inner {
    height: 60px;
    border-radius: 8px 8px 8px 8px;
  }
  .el-input-group__append {
    cursor: pointer;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid var(--primary-color);
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: var(--primary-color);
    padding: 0 24px;
    width: auto;
    display: flex;
    align-items: center;
  }
  .el-form-item {
    margin-bottom: 12px;
  }
}
.mt8 {
  margin-top: 8px;
}
.p1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 36px;
  color: #333333;
}
.p2 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #333333;
}
.p3 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
}
.sp1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
}
.sp2 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 32px;
  color: var(--primary-color);
}
.box1 {
  width: 480px;
  height: 160px;
  overflow: hidden;
  padding-left: 20px;
  background: #ffffff;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 12px 12px 12px 12px;
  background-image: url(~@/assets/img/images/member-bj.png);
}
.close-img {
  width: 14px;
  height: 14px;
  top: 20px;
  right: 20px;
  cursor: pointer;
  position: absolute;
}
.btn-box {
  gap: 10px;
  display: flex;
  margin-top: 32px;
  .btn1 {
    flex: 1;
    cursor: pointer;
    height: 48px;
    line-height: 48px;
    text-align: center;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid var(--primary-color);
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: var(--primary-color);
  }
  .btn2 {
    flex: 1;
    height: 48px;
    cursor: pointer;
    line-height: 48px;
    text-align: center;
    background: var(--primary-color);
    border-radius: 8px 8px 8px 8px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: var(--white-color);
  }
}
</style>
